import React, { ReactPortal, useEffect } from 'react'
import { Typography, Box, Button, IconButton } from '@material-ui/core'
import ReactDOM from 'react-dom'
import { useAppState } from 'Context/AppContext/AppContext'
import { Close as CloseIcon } from '@material-ui/icons'
import { Text } from '@resiliatech/birdsong'
import useStyles from './styles.styles'

type Props = {
  title?: string
  buttonText?: string
  buttonOnClickHandler?: () => void
  hideButton?: boolean
  withBackdrop?: boolean
  showAppBarWithBackdrop?: boolean
  withCloseIcon?: boolean
  backdropClickHandler?: () => void
  children?: React.ReactNode
  containerStyle?: React.CSSProperties | any
  showSecondaryButton?: boolean
  secondaryButtonText?: string
  secondaryButtonHandler?: () => void
}

const StaticPopupModal: React.FC<Props> = ({
  title,
  buttonText,
  buttonOnClickHandler,
  children,
  hideButton,
  withBackdrop = false,
  showAppBarWithBackdrop = false,
  withCloseIcon = true,
  backdropClickHandler,
  containerStyle = {},
  showSecondaryButton,
  secondaryButtonText,
  secondaryButtonHandler,
}) => {
  const classes = useStyles({ withCloseIcon })

  const {
    ui: { showNavigation },
  } = useAppState()

  const appRoot = document.querySelector('body')
  useEffect(() => {
    if (appRoot) appRoot.style.overflow = 'hidden'

    return () => {
      if (appRoot) appRoot.style.overflow = 'initial'
    }
  }, [appRoot])

  if (appRoot) {
    return ReactDOM.createPortal(
      <>
        {withBackdrop && backdropClickHandler && (
          <Box
            className={`${classes.backgroundContainer} ${
              withBackdrop && showAppBarWithBackdrop && showNavigation
                ? 'showDrawer'
                : ''
            }`}
            onClick={() => backdropClickHandler()}
          />
        )}
        <Box
          className={`${classes.staticPopupContainer} ${
            showNavigation ? 'withDrawer' : ''
          }`}
          style={containerStyle}
        >
          {withCloseIcon && backdropClickHandler && (
            <IconButton
              size='small'
              className={classes.closeIcon}
              onClick={() => backdropClickHandler()}
            >
              <CloseIcon />
            </IconButton>
          )}
          {title && <Text variant='h1'>{title}</Text>}
          {children}
          {showSecondaryButton && (
            <Button
              className={classes.secondaryButton}
              onClick={secondaryButtonHandler}
              variant='text'
            >
              {secondaryButtonText}
            </Button>
          )}
          {!hideButton && (
            <Button
              className={classes.primaryButton}
              onClick={buttonOnClickHandler}
              variant='contained'
            >
              {buttonText}
            </Button>
          )}
        </Box>
      </>,
      appRoot
    )
  }
  return null
}

export default StaticPopupModal
